module.exports = "./static/icon_error.a146414b.png";